import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classnames from "classnames";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo } from "react";
import { InquiryForm } from "@/components/Form/index";
import InquiryMetaTags from "@/components/MetaTags/InquiryMetaTags";
import Steps from "@/components/Steps";
import { useAuthUserQuery, useDeviceInfoQuery, useStep, useTermsQuery, useInquiryMutation } from "@/hooks";
import { inquiryList } from "@/lib/constants";
import routes from "@/lib/routes";
import processStyles from "@/styles/Process.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var __N_SSP = true;
export default function InquiryStep(_ref) {
  let {
    gip
  } = _ref;
  const router = useRouter();
  const {
    data: {
      user
    }
  } = useAuthUserQuery();
  const [inquiry] = useInquiryMutation();
  const {
    step,
    state,
    dispatch
  } = useStep({}, {
    completeStep: 3
  });
  const pageBack = useCallback(e => {
    e.preventDefault();
    dispatch({
      type: "prev"
    });
  }, [dispatch]);
  const handleStep1 = useCallback(async data => {
    return new Promise(resolve => {
      dispatch({
        type: "next",
        formData: data
      });
      resolve();
    });
  }, [dispatch]);
  const handleStep2 = useCallback(
  //お問合せ内容送信処理
  async data => {
    return new Promise((resolve, reject) => {
      try {
        const params = {
          name: (data === null || data === void 0 ? void 0 : data.name) || (user === null || user === void 0 ? void 0 : user.fullName),
          mailAddress: (data === null || data === void 0 ? void 0 : data.mailAddress) || (user === null || user === void 0 ? void 0 : user.mailAddress),
          subject: inquiryList === null || inquiryList === void 0 ? void 0 : inquiryList[data === null || data === void 0 ? void 0 : data.commentOption],
          body: data === null || data === void 0 ? void 0 : data.comment,
          comment: `UA:${data === null || data === void 0 ? void 0 : data.ua}\nGIP:${data === null || data === void 0 ? void 0 : data.gip}`
        };
        try {
          inquiry({
            variables: params
          });
        } catch (e) {
          throw e;
        }
        //次のstepへ
        dispatch({
          type: "next"
        });
        resolve();
      } catch (e) {
        reject();
      }
    });
  }, [user, dispatch, inquiry]);
  const {
    data: termsData
  } = useTermsQuery({
    variables: {
      keys: ["skp_privacypolicy"],
      withAgreement: true
    }
  });
  const privacypolicy = useMemo(() => {
    if (termsData) {
      var _termsData$terms, _termsData$terms2;
      return _objectSpread({
        display_name: termsData === null || termsData === void 0 || (_termsData$terms = termsData.terms) === null || _termsData$terms === void 0 || (_termsData$terms = _termsData$terms[0]) === null || _termsData$terms === void 0 ? void 0 : _termsData$terms.display_name
      }, termsData === null || termsData === void 0 || (_termsData$terms2 = termsData.terms) === null || _termsData$terms2 === void 0 || (_termsData$terms2 = _termsData$terms2[0]) === null || _termsData$terms2 === void 0 ? void 0 : _termsData$terms2.current_revision);
    } else {
      return null;
    }
  }, [termsData]);
  useEffect(() => {
    //stepの URL更新
    if (step !== state.nextStep) {
      router.push(routes.inquiryStep(state.nextStep), undefined, {
        shallow: true,
        scroll: true
      });
    }
  }, [router, step, state.nextStep]);
  const {
    data: {
      deviceInfo
    } = {}
  } = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  });
  const action = useMemo(() => {
    if (step === 1) return "index";
    if (step === 2) return "confirm";
    if (step === 3) return "complete";
  }, [step]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(InquiryMetaTags, {
      action: action
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(processStyles.container, {
        [processStyles.complete]: step === 3
      }),
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.inner,
        children: [step !== 3 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("h2", {
            className: processStyles.heading,
            children: "\u304A\u554F\u3044\u5408\u308F\u305B"
          }), /*#__PURE__*/_jsx(Steps, {
            step: step,
            steps: ["お問い合わせ内容入力", "入力内容の確認", "お問い合わせ完了"]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [step === 1 && /*#__PURE__*/_jsx(InquiryForm.Step1, {
            onSubmit: handleStep1,
            user: user,
            formData: state.formData,
            privacypolicy: privacypolicy
          }), step === 2 && /*#__PURE__*/_jsx(InquiryForm.Step2, {
            onSubmit: handleStep2,
            pageBack: pageBack,
            formData: state.formData,
            user: user,
            privacypolicy: privacypolicy,
            gip: gip,
            ua: deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.ua
          }), step === 3 && /*#__PURE__*/_jsx(InquiryForm.Step3, {})]
        })]
      })
    })]
  });
}
InquiryStep.layout = "NoHeaderLayout";